export default __webpack_public_path__ + "static/social-google-v3-c59cab0d30d27f07b90a4a2de78e28ad.svg";